<template>
  <div class="form-page height-spacer">
    <div v-if="showInput" class="customSelect form-input__wrap" :class="{open: open, error: history[currentStep].showError}">
      <div class="controls dnt-cl" @click="openSelect">
        <span class="value dnt-cl" :class="{inputPlacehoder: !inputVal}">{{inputVal || history[currentStep].field.placeholder}}</span>
        <img class="search_placeholder" src="https://cdn.crezu.net/game_flow/src/assets/img/search_icon.svg">
        <input
          class="search form-input dnt-cl"
          @input="updateList"
          v-model="search"
          ref="search"
          type="text"
          :name="history[currentStep].name"
          :placeholder="history[currentStep].field.placeholder"
          required>
        <span class="form-input-floating-label">{{history[currentStep].field.placeholder}}</span>
        <div class="arrow dnt-cl"></div>
      </div>
      <ul class="options">
        <li
          v-for="(value, index) in filteredValues"
          :key="index"
          :class="{hoveredOption: value === inputVal}"
          @click="selectOption(value)">{{value}}</li>
        <li v-if="!filteredValues.length" class="inputPlacehoder"><b>{{emptyList}}</b></li>
      </ul>
    </div>
    <transition name="fade">
      <span class="error-message" v-if="history[currentStep].showError">
        {{history[currentStep].field.error}}
      </span>
    </transition>
    <div class="tooltip province-tooltip" v-if="history[currentStep].field.tooltip">
      <span class="icon icon-info-line"><info-icon/></span>
      <p class="tooltip-text" v-html="history[currentStep].field.tooltip">
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InfoIcon from '../assetComponents/InfoIcon'
const levenshtein = require('fast-levenshtein')

export default {
  name: 'InputAutocomplete',
  components: { InfoIcon },
  data () {
    return {
      inputVal: '',
      initValue: false,
      open: false,
      values: [],
      filteredValues: [],
      search: '',
      temporaryBlocked: false
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      fieldData: state => state.history[state.currentStep].field,
      showInput: state => state.showInput,
      config: state => state.config,
      provider: state => state.additionalParams.provider,
      country: state => state.additionalParams.country,
    }),
    initialValues () {
      if (this.fieldData) return this.fieldData.values
      return []
    },
    translate () {
      if (this.fieldData) return this.fieldData.translate
      return {}
    },
    emptyList () {
      if (this.country === 14) return 'Empty list'
      return 'Elige de la lista'
    }
  },
  mounted () {
    let previosVal = this.history[this.currentStep].value
    if (this.history[this.currentStep].name === 'province') {
      this.values = this.fieldData.provinces
    } else if (this.country === 2 && this.history[this.currentStep].name === 'car_model') {
      const carBrand = this.$store.getters.getFieldValue('car_brand')
      this.values = [...(this.fieldData.models && this.fieldData.models[carBrand] || []), 'Otro']
    } else if (this.initialValues && this.initialValues.length) {
      this.values = this.fieldData.values
      console.log('set values from "values" key')
    } else if (this.translate) { // set values from translate object
      this.values = Object.keys(this.translate)
      for (let i in this.translate) {
        if (this.translate[i] === previosVal) previosVal = i
      }
      console.log('set values from "translate" key')
    } else {
      this.values = []
    }
    this.filteredValues = this.values
    window.addEventListener('click', this.closeMenu)

    if (previosVal) this.selectOption(previosVal, true)
  },
  beforeDestroy () {
    window.removeEventListener('click', this.closeMenu)
  },
  methods: {
    selectOption (val, dontTrigger) {
      this.inputVal = val
      if (this.translate && Object.keys(this.translate).length) { // set value from translate object
        const translated = this.translate[val]
        console.log('translate selected val:', val, '->', translated )
        val = translated
      }
      this.open = false
      this.$store.commit('UPDATE_FIELD', { isValid: true, value: val })
    },
    openSelect () {
      this.open = true
      console.log(this.$refs.search)
      // this.$refs.search.focus()
      setTimeout(() => {
        this.$refs.search.focus()
      }, 100)
    },
    updateList () {
      this.filteredValues = this.values.filter(x => {
        // x.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        const distance = levenshtein.get(this.search, x.slice(0, this.search.length), { useCollator: true })
        return !distance
      })
      if (this.filteredValues.length === 1 && !this.temporaryBlocked) {
        console.log('autoselect:', this.filteredValues[0])
        // we need to block handler because user can type so fast and it calls multiple handlers (we dont want it)
        // this.temporaryBlocked = true
        this.selectOption(this.filteredValues[0], true)
        // setTimeout(() => {
        //   this.temporaryBlocked = false
        // }, 100)
      }
    },
    closeMenu (e) {
      if (e.target.className.indexOf('dnt-cl') === -1) {
        this.open = false
        // reset filter state
        this.search = ''
        this.updateList()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/scss/inputautocomplete";
</style>



// WEBPACK FOOTER //
// src/components/fields/InputAutocomplete.vue